const languageOptions = [
  {
    text: 'English',
    id: 'en',
  },
  {
    text: 'Hindi',
    id: 'hi',
  },
  {
    text: 'Kannada',
    id: 'kn',
  },
  {
    text: 'Arabic',
    id: 'ar',
  },
  {
    text: 'Pashto',
    id: 'ps',
  },
  {
    text: 'Swedish',
    id: 'sv',
  },
  {
    text: 'Albanian',
    id: 'sq',
  },
  {
    text: 'Catalan',
    id: 'ca',
  },
  {
    text: 'Portuguese',
    id: 'pt',
  },
  {
    text: 'Spanish',
    id: 'es',
  },
  {
    text: 'Armenian',
    id: 'hy',
  },
  {
    text: 'Dutch',
    id: 'nl',
  },
  {
    text: 'German',
    id: 'de',
  },
  {
    text: 'Azerbaijani',
    id: 'az',
  },
  {
    text: 'Bengali',
    id: 'bn',
  },
  {
    text: 'Belarusian',
    id: 'be',
  },
  {
    text: 'French',
    id: 'fr',
  },
  {
    text: 'Dzongkha',
    id: 'dz',
  },
  {
    text: 'Bosnian',
    id: 'bs',
  },
  {
    text: 'Norwegian',
    id: 'no',
  },
  {
    text: 'Malay',
    id: 'ms',
  },
  {
    text: 'Bulgarian',
    id: 'bg',
  },
  {
    text: 'Khmer',
    id: 'km',
  },
  {
    text: 'Chinese',
    id: 'zh',
  },
  {
    text: 'Croatian',
    id: 'hr',
  },
  {
    text: 'Greek (modern)',
    id: 'el',
  },
  {
    text: 'Czech',
    id: 'cs',
  },
  {
    text: 'Danish',
    id: 'da',
  },
  {
    text: 'Tigrinya',
    id: 'ti',
  },
  {
    text: 'Estonian',
    id: 'et',
  },
  {
    text: 'Amharic',
    id: 'am',
  },
  {
    text: 'Faroese',
    id: 'fo',
  },
  {
    text: 'Finnish',
    id: 'fi',
  },
  {
    text: 'Georgian',
    id: 'ka',
  },
  {
    text: 'Kalaallisut',
    id: 'kl',
  },
  {
    text: 'Latin',
    id: 'la',
  },
  {
    text: 'Hungarian',
    id: 'hu',
  },
  {
    text: 'Icelandic',
    id: 'is',
  },
  {
    text: 'Indonesian',
    id: 'id',
  },
  {
    text: 'Persian (Farsi)',
    id: 'fa',
  },
  {
    text: 'Irish',
    id: 'ga',
  },
  {
    text: 'Hebrew (modern)',
    id: 'he',
  },
  {
    text: 'Italian',
    id: 'it',
  },
  {
    text: 'Japanese',
    id: 'ja',
  },
  {
    text: 'Kazakh',
    id: 'kk',
  },
  {
    text: 'Kyrgyz',
    id: 'ky',
  },
  {
    text: 'Lao',
    id: 'lo',
  },
  {
    text: 'Latvian',
    id: 'lv',
  },
  {
    text: 'Lithuanian',
    id: 'lt',
  },
  {
    text: 'Macedonian',
    id: 'mk',
  },
  {
    text: 'Malaysian',
    id: 'null',
  },
  {
    text: 'Divehi',
    id: 'dv',
  },
  {
    text: 'Maltese',
    id: 'mt',
  },
  {
    text: 'Romanian',
    id: 'ro',
  },
  {
    text: 'Mongolian',
    id: 'mn',
  },
  {
    text: 'Serbian',
    id: 'sr',
  },
  {
    text: 'Burmese',
    id: 'my',
  },
  {
    text: 'Nepali',
    id: 'ne',
  },
  {
    text: 'Korean',
    id: 'ko',
  },
  {
    text: 'Polish',
    id: 'pl',
  },
  {
    text: 'Russian',
    id: 'ru',
  },
  {
    text: 'Kinyarwanda',
    id: 'rw',
  },
  {
    text: 'Samoan',
    id: 'sm',
  },
  {
    text: 'Slovak',
    id: 'sk',
  },
  {
    text: 'Slovene',
    id: 'sl',
  },
  {
    text: 'Somali',
    id: 'so',
  },
  {
    text: 'Afrikaans',
    id: 'af',
  },
  {
    text: 'Sinhalese',
    id: 'si',
  },
  {
    text: 'Tajik',
    id: 'tg',
  },
  {
    text: 'Swahili',
    id: 'sw',
  },
  {
    text: 'Thai',
    id: 'th',
  },
  {
    text: 'Turkish',
    id: 'tr',
  },
  {
    text: 'Turkmen',
    id: 'tk',
  },
  {
    text: 'Ukrainian',
    id: 'uk',
  },
  {
    text: 'Uzbek',
    id: 'uz',
  },
  {
    text: 'Bislama',
    id: 'bi',
  },
  {
    text: 'Vietnamese',
    id: 'vi',
  },
  {
    text: 'Tamil',
    id: 'ta',
  },
  {
    text: 'Tamil (India)',
    id: 'ta-IN',
  },
  {
    text: 'Gujarati',
    id: 'gu',
  },
  {
    text: 'Gujarati (India)',
    id: 'gu-IN',
  },
  {
    text: 'Kannada (India)',
    id: 'kn-IN',
  },
  {
    text: 'Marathi',
    id: 'mr',
  },
  {
    text: 'Marathi (India)',
    id: 'mr-IN',
  },
  {
    text: 'Punjabi',
    id: 'pa',
  },
  {
    text: 'Punjabi (India)',
    id: 'pa-IN',
  },
  {
    text: 'Sanskrit',
    id: 'sa',
  },
  {
    text: 'Sanskrit (India)',
    id: 'sa-IN',
  },
  {
    text: 'Telugu',
    id: 'te',
  },
  {
    text: 'Telugu (India)',
    id: 'te-IN',
  },
  {
    text: 'Malayalam',
    id: 'ml',
  },
]

export default languageOptions
